import axios from 'axios';

/**
 * 获取管理员列表
 */
export const getAdmins = () => {
  return axios.get('/api/admins');
};


/**
 * 获取管理员信息，关联的项目及管理处
 */
export const getAdmin = ({ id }) => {
  return axios.get(`/api/admins/${id}`);
};


/**
 * 创建普通管理员
 */
export const createAdmin = (params) => {
  return axios.post('/api/admins', params);
};


/**
 * 删除普通管理员
 */
export const deleteAdmin = (params) => {
  return axios.delete(`/api/admins/${params.id}`);
};


/**
 * 关联项目
 */
export const associateProject = (params) => {
  const { adminId, projectId, isAssociate } = params;
  return axios.post(`/api/admins/${adminId}/associateProject`, { projectId, isAssociate });
};


/**
 * 关联管理处
 */
export const associateBranches = (params) => {
  const { adminId, projectId, branchIds } = params;
  return axios.post(`/api/admins/${adminId}/associateBranches`, { projectId, branchIds });
};

/**
 * 设置普通账号管理权限
 */
export const updateAdminPermission = ({ adminId, canEdit }) => {
  return axios.post(`/api/admins/${adminId}/permission`, { canEdit });
};

export const getAdminByUsername = ({ username }) => {
  return axios.get(`/api/admins/username/${username}`);
};
